<mat-list>
  <mat-list-item *ngFor="let customField of filtered()" fxLayoutGap="5px">
    <custom-field-inline-editor
      class="inline-attribute-editor"
      fxFlex="99"
      [editable]="editable"
      [customFieldValues]="customFieldValues | customFieldValueByIdPipe: customField.id"
      [customField]="customField"
      [saveFn]="saveFn"
      [deleteFn]="deleteFn"
      [useDescription]="useDescription"
      [id]="customField.id"
      [entityId]="entityId"
      [attributeEditorMode]="attributeEditorMode"
      (addOrUpdateComplexValue)="addOrUpdateComplexValue.emit($event)"
    ></custom-field-inline-editor>
  </mat-list-item>
</mat-list>
